import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/settings/custom-modules/$key/permissions')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/settings/roles?module=${params.key}` })
  },
})
